import Store from "@/store";
import providers from "@/lib/api";

export default function useUserTags() {
  const userTagsUpdateData = async (tags: string[]) => {
    if (!Store.state.user?.id) {
      throw new Error("There is no authorized user");
    }
    const data: { fields: any } = { fields: { tags } };
    data.fields.userId = Store.state.user.id;
    const result = await providers.QuestionaryInfoProvider.update({ data });
    return ((result.fields.tags as any) as number[]).map(t => t.toString());
  };
  const userTagsGetData = async () => {
    if (!Store.state.user?.id) {
      throw new Error("There is no authorized user");
    }
    const result = await providers.QuestionaryInfoProvider.find({ id: Store.state.user.id });
    return ((result.fields.tags as any) as number[]).map(t => t.toString());
  };

  return { userTagsUpdateData, userTagsGetData };
}
